// a tabs component with 1 tab

// chatbot


import React, { useState, useEffect } from 'react';
import { Tabs, Table, DatePicker, Input, Button, Space, Select, Tag } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { collection, query, getDocs, where, orderBy } from 'firebase/firestore';
import { db } from '../../../firebase/setup';
import moment from 'moment';

const { TabPane } = Tabs;
const { RangePicker } = DatePicker;
const { Option } = Select;

const ChatbotLogs = () => {
    const [loading, setLoading] = useState(false);
    const [chatLogs, setChatLogs] = useState([]);
    const [filteredLogs, setFilteredLogs] = useState([]);
    const [dateRange, setDateRange] = useState(null);
    const [searchText, setSearchText] = useState('');
    const [searchEmail, setSearchEmail] = useState('');
    const [searchPath, setSearchPath] = useState('');

    useEffect(() => {
        fetchChatLogs();
    }, []);

    useEffect(() => {
        applyFilters();
    }, [chatLogs, dateRange, searchText, searchEmail, searchPath]);

    const fetchChatLogs = async () => {
        setLoading(true);
        try {
            const chatbotsRef = collection(db, "ChatbotHistory");
            const q = query(chatbotsRef, orderBy("timestamp", "desc"));
            const querySnapshot = await getDocs(q);
            
            const logs = [];
            querySnapshot.forEach((doc) => {
                logs.push({
                    id: doc.id,
                    ...doc.data(),
                    timestamp: doc.data().timestamp?.toDate() || new Date()
                });
            });
            
            setChatLogs(logs);
            setFilteredLogs(logs);
        } catch (error) {
            console.error("Error fetching chatbot logs:", error);
        } finally {
            setLoading(false);
        }
    };

    const applyFilters = () => {
        let filtered = [...chatLogs];

        // Apply date range filter
        if (dateRange && dateRange[0] && dateRange[1]) {
            const startDate = dateRange[0].startOf('day');
            const endDate = dateRange[1].endOf('day');
            
            filtered = filtered.filter(log => {
                const logDate = moment(log.timestamp);
                return logDate.isBetween(startDate, endDate, null, '[]');
            });
        }

        // Apply text search filter
        if (searchText) {
            const lowerSearchText = searchText.toLowerCase();
            filtered = filtered.filter(log => 
                (log.query && log.query.toLowerCase().includes(lowerSearchText)) || 
                (log.response && log.response.toLowerCase().includes(lowerSearchText))
            );
        }

        // Apply email filter
        if (searchEmail) {
            const lowerSearchEmail = searchEmail.toLowerCase();
            filtered = filtered.filter(log => 
                log.userEmail && log.userEmail.toLowerCase().includes(lowerSearchEmail)
            );
        }

        // Apply path filter
        if (searchPath) {
            const lowerSearchPath = searchPath.toLowerCase();
            filtered = filtered.filter(log => 
                log.currentPath && log.currentPath.toLowerCase().includes(lowerSearchPath)
            );
        }

        setFilteredLogs(filtered);
    };

    const resetFilters = () => {
        setDateRange(null);
        setSearchText('');
        setSearchEmail('');
        setSearchPath('');
        setFilteredLogs(chatLogs);
    };

    const columns = [
        {
            title: 'Date & Time',
            dataIndex: 'timestamp',
            key: 'timestamp',
            render: (timestamp) => moment(timestamp).format('YYYY-MM-DD HH:mm:ss'),
            sorter: (a, b) => new Date(a.timestamp) - new Date(b.timestamp),
            width: 180,
        },
        {
            title: 'User Email',
            dataIndex: 'userEmail',
            key: 'userEmail',
            width: 200,
        },
        {
            title: 'User Query',
            dataIndex: 'query',
            key: 'query',
            render: (text) => (
                <div style={{ maxHeight: '100px', overflow: 'auto' }}>
                    {text}
                </div>
            ),
        },
        {
            title: 'AI Response',
            dataIndex: 'response',
            key: 'response',
            render: (text) => (
                <div style={{ maxHeight: '150px', overflow: 'auto' }}>
                    {text}
                </div>
            ),
        },
        {
            title: 'Page Path',
            dataIndex: 'currentPath',
            key: 'currentPath',
            width: 200,
            render: (path) => (
                <Tag color="blue">{path}</Tag>
            ),
        },
    ];

    return (
        <div>
            <h1>Chatbot Logs</h1>
            
            <Space direction="vertical" style={{ width: '100%', marginBottom: 16 }}>
                <Space wrap>
                    <RangePicker 
                        value={dateRange}
                        onChange={(dates) => setDateRange(dates)}
                        allowClear
                    />
                    
                    <Input 
                        placeholder="Search in query/response" 
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        prefix={<SearchOutlined />}
                        allowClear
                    />
                    
                    <Input 
                        placeholder="Filter by email" 
                        value={searchEmail}
                        onChange={(e) => setSearchEmail(e.target.value)}
                        allowClear
                    />
                    
                    <Input 
                        placeholder="Filter by path" 
                        value={searchPath}
                        onChange={(e) => setSearchPath(e.target.value)}
                        allowClear
                    />
                    
                    <Button type="primary" onClick={fetchChatLogs}>
                        Refresh
                    </Button>
                    
                    <Button onClick={resetFilters}>
                        Reset Filters
                    </Button>
                </Space>
                
                <div>
                    <strong>Total Records:</strong> {filteredLogs.length} (of {chatLogs.length})
                </div>
            </Space>
            
            <Table 
                columns={columns} 
                dataSource={filteredLogs} 
                rowKey="id"
                loading={loading}
                pagination={{ 
                    pageSize: 10,
                    showSizeChanger: true,
                    pageSizeOptions: ['10', '20', '50', '100'],
                }}
                scroll={{ x: 1200 }}
            />
        </div>
    );
};

const Logs = () => {    
    return (
        <Tabs>
            <TabPane tab="Chatbot" key="1">
                <ChatbotLogs />
            </TabPane>
        </Tabs>
    );
};

export default Logs;





